import React from "react";
import { search } from "../data/content";
import { surface } from "../data/theme";
import { Punchline } from "./Punchline";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
export function SearchProblem() {
  return <Section labelledBy="search-title" className="bg-mist text-center" waveTo={surface.navy} data-id="element-189" data-mp="37fldocokpraz">
      <Reveal data-id="element-190" data-mp="2tg3nptzjk801">
        <SectionTitle id="search-title" title={search.title} highlight={search.highlight} after={search.after} data-id="element-191" data-mp="2tfkcsx8b6jvi" />
        <p className="mt-6 text-left leading-relaxed text-navy/80 sm:text-[17px]" data-id="element-192" data-mp="2xiqgpy7y7yyt">{search.text}</p>
        <Punchline text={search.punchline} className="mt-6" data-id="element-193" data-mp="2jixtwdzjm2w4" />
      </Reveal>
    </Section>;
}